var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClosed = function SvgClosed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4165 0.250075C14.0915 -0.0749249 13.5665 -0.0749249 13.2415 0.250075L8.54154 4.95008L9.71654 6.12508L14.4165 1.41674C14.7332 1.10007 14.7332 0.566742 14.4165 0.250075ZM17.9499 0.241742L9.71654 8.47508L6.81654 5.58341C6.49154 5.25841 5.96654 5.25841 5.64154 5.58341C5.31654 5.90841 5.31654 6.43341 5.64154 6.75841L9.12487 10.2417C9.44987 10.5667 9.97487 10.5667 10.2999 10.2417L19.1249 1.42508C19.4499 1.10008 19.4499 0.575075 19.1249 0.250075H19.1165C18.7999 -0.0832582 18.2749 -0.0832584 17.9499 0.241742ZM0.933203 6.76674L4.41654 10.2501C4.74154 10.5751 5.26654 10.5751 5.59154 10.2501L6.17487 9.66674L2.1082 5.58341C1.7832 5.25841 1.2582 5.25841 0.933203 5.58341C0.608203 5.90841 0.608203 6.44174 0.933203 6.76674Z",
    fill: "#777776"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClosed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closed.ec1156c8.svg";
export { ForwardRef as ReactComponent };